if (!customElements.get('favorite-products')) {
  customElements.define(
    'favorite-products',
    class FavoriteProducts extends HTMLElement {
      constructor() {
        super();
      }

      static get observedAttributes() {
        return ['selected-index'];
      }

      get selectedIndex() {
        return parseInt(this.getAttribute('selected-index')) || 0;
      }

      set selectedIndex(index) {
        this.setAttribute('selected-index', `${index}`);
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';

        if (!this.enableSlider) return;

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderInstance = false;
        this.initSlider();
      }

      initSlider() {
        const spaceBetween = parseInt(this.dataset.itemGap);

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.section.querySelector('.swiper-button-next'),
            prevEl: this.section.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.section.querySelector('.swiper-pagination'),
            clickable: true,
            renderBullet: function(index, className) {
              return `<button class="${className}"></button>`;
            },
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          autoHeight: true,
          loop: true,
          threshold: 2,
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.querySelector('.swiper'), this.sliderOptions, [
          FoxTheme.Swiper.EffectFade,
        ]);
        this.sliderInstance.init();

        // Set aria-labels synchronously after init so they are always present.
        const slider = this.sliderInstance.slider;
        if (slider.pagination && slider.pagination.bullets && slider.pagination.bullets.length) {
          const total = slider.pagination.bullets.length;
          slider.pagination.bullets.forEach((bullet, i) => {
            bullet.setAttribute('aria-label', `Go to slide ${i + 1} of ${total}`);
            if (i === slider.realIndex) bullet.setAttribute('aria-current', 'true');
          });
        }

        this.sliderInstance.slider.on('realIndexChange', this.onSlideChange.bind(this));
        this.sliderCounter = this.querySelector('.swiper-pagination-counter');
        this.liveRegion = this.section.querySelector('.swiper-live-region');

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideToLoop(index);
          });
        }
        this.fixQuickviewDuplicate();
      }
      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      onSlideAfterInit(swiper) {
        const { realIndex } = swiper;
        if (this.sliderCounter && swiper.pagination.bullets) {
          this.sliderCounter.querySelector('.swiper-pagination-current').innerText = realIndex + 1;
          this.sliderCounter.querySelector('.swiper-pagination-total').innerText = swiper.pagination.bullets.length;
        }

        this.detectVisibleSlides(swiper);
      }

      onSlideChange(swiper) {
        const { realIndex } = swiper;
        this.selectedIndex = realIndex;

        if (swiper.pagination && swiper.pagination.bullets.length) {
          swiper.pagination.bullets.forEach((bullet, i) => {
            if (i === realIndex) {
              bullet.setAttribute('aria-current', 'true');
            } else {
              bullet.removeAttribute('aria-current');
            }
          });
        }

        this.announceSlide(swiper);
      }

      // Announce the newly active slide to assistive technology (WCAG 4.1.3 Status Messages).
      announceSlide(swiper) {
        if (!this.liveRegion) return;

        // bullets reflect real slides (loop duplicates are excluded), matching realIndex.
        const bullets = swiper.pagination && swiper.pagination.bullets;
        const total = bullets && bullets.length ? bullets.length : swiper.slides.length;
        const position = `Slide ${swiper.realIndex + 1} of ${total}`;

        const activeSlide = swiper.slides[swiper.activeIndex];
        const title = activeSlide && activeSlide.querySelector('.testimonial__title');
        const label = title && title.textContent.trim();

        this.liveRegion.textContent = label ? `${position}: ${label}` : position;
      }

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'selected-index' && oldValue !== newValue) {
          if (oldValue !== null) {
            const fromElements = this.querySelectorAll(`[data-swiper-slide-index="${oldValue}"]`);
            fromElements.forEach((fromElement) => {
              const motionEls = fromElement.querySelectorAll('motion-element');
              motionEls &&
                motionEls.forEach((motionEl) => {
                  if (motionEl.hasAttribute('data-text')) {
                    motionEl.resetAnimation();
                  }
                });
            });
          }

          const toElements = this.querySelectorAll(`[data-swiper-slide-index="${newValue}"]`);
          toElements.forEach((toElement) => {
            setTimeout(() => {
              if (toElement.classList.contains('swiper-slide-active')) {
                const motionEls = toElement.querySelectorAll('motion-element');
                motionEls.forEach((motionEl) => {
                  motionEl && motionEl.refreshAnimation();
                });
              }
            });
          });
        }
      }
    }
  );
}
